import { createFileRoute } from "@tanstack/react-router";

import { MetricsInnerTabs } from "~/components/feature/metrics/pages";

export const Route = createFileRoute("/_app/dashboard/metrics/solvency")({
  component: RouteComponent,
});

function RouteComponent() {
  return <MetricsInnerTabs group="solvency" />;
}
